import { cookieHelpers } from './cookieUtils';

/**
 * Extract distributor information and formatted name from user profile data
 * @param userProfilesData - User profile data object containing user and distributor_info
 * @returns Object containing distributorInfo and a formatted distributorName string
 * @example
 * const { distributorInfo, distributorName } = getDistributorInfoAndName(profileData);
 * // distributorName will be "John Doe" or empty string if no distributor info
 */
export function getDistributorInfoAndName(userProfilesData: any): {
    distributorInfo: any | null;
    distributorName: string;
} {
    const profile = userProfilesData as any;
    const distributorInfo = profile?.user?.distributor_info;
    const distributorName = distributorInfo ? `${distributorInfo.first_name} ${distributorInfo.last_name || ''}`.trim() : '';
    return { distributorInfo, distributorName };
}

/**
 * Check if a JWT token is expired and remove it from cookies if expired
 * @param token - The JWT token to check
 * @returns true if token is expired or invalid, false if valid
 */
export const isTokenExpired = (token: string | null): boolean => {
  if (!token || token === 'undefined' || token.trim() === '') {
    return true;
  }

  try {
    // JWT tokens have 3 parts separated by dots
    const parts = token.split('.');
    if (parts.length !== 3) {
      return true;
    }

    // Decode the payload (second part)
    const payload = parts[1];
    const decodedPayload = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    const tokenData = JSON.parse(decodedPayload);

    // Check if token has expiration time
    if (!tokenData.exp) {
      return true;
    }

    // exp is in seconds, Date.now() is in milliseconds
    const currentTime = Math.floor(Date.now() / 1000);
    const expired = tokenData.exp < currentTime;
    
    // If token is expired, remove it from cookies
    if (expired) {
      cookieHelpers.removeToken();
      cookieHelpers.removeUserId();
    }
    
    return expired;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    // If there's an error parsing the token, remove it as it's invalid
    cookieHelpers.removeToken();
    cookieHelpers.removeUserId();
    return true;
  }
};
